export default {
  container: {
    border: '1px solid #ddd'
  },
  title: {
    background: '#ddd',
    height: '40px',
    lineHeight: '40px',
    color: '#333',
    fontSize: '14px',
    padding: '0px 20px'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Container/style.js